
  const staffRequirement = {
    path: "/staffRequirement",
    name: "staffRequirement",
    component: () => import(/* webpackChunkName: "staff_requirement" */ "@/components/staffRequirement/StaffRequirementIndex.vue"),
    children: [
      { path: "view/:id", component: () => import(/* webpackChunkName: "staff_requirement" */ "@/components/staffRequirement/StaffRequirementView.vue"), name: "staffRequirementView" },
      { path: "edit/:id", component: () => import(/* webpackChunkName: "staff_requirement" */ "@/components/staffRequirement/StaffRequirementEdit.vue"), name: "staffRequirementEdit" },
      { path: "create", component: () => import(/* webpackChunkName: "staff_requirement" */ "@/components/staffRequirement/StaffRequirementCreate.vue"), name: "staffRequirementCreate"}
    ],
    meta: { authorize: [], requiresAuth: true }
  };

export default staffRequirement;
    